"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockPropertiesMap = exports.mockProperty = void 0;
const helpers_1 = require("../helpers");
const mockProperty = (overrides) => {
    const uid = overrides?.uid || helpers_1.chance.guid();
    return {
        uid,
        order: helpers_1.chance.integer({ max: 10 }),
        key: uid,
        valueType: helpers_1.chance.pickone(["string", "number", "boolean", "vector2", "vector3"]),
        name: helpers_1.chance.name(),
        value: helpers_1.chance.animal(),
        ...overrides,
    };
};
exports.mockProperty = mockProperty;
const mockPropertiesMap = (propertiesAmount = helpers_1.chance.integer({ min: 1, max: 20 }), overrides) => {
    const results = {};
    for (let i = 0; i < propertiesAmount; i++) {
        const prop = (0, exports.mockProperty)();
        results[prop.uid] = prop;
    }
    return { ...results, ...overrides };
};
exports.mockPropertiesMap = mockPropertiesMap;
//# sourceMappingURL=mockPropertyData.js.map